import Vue from 'vue';
import moment from 'moment'

Vue.filter("stringToDateStringFormat", value => {
  if (value) { return moment(String(value)).format('MM/DD/YYYY hh:mm')}
})

Vue.filter("dateToStringFormat", value => {
  if (value) {return moment(value).format('ddd, MM/DD/YYYY hh:mm')}
})

Vue.filter("monthDateFormat", value => {
  if (value) { return moment(value).format('MM/YYYY')}
})

Vue.filter("stringDateToMonthDateFormat", value => {
  if (value) { return moment(value).format('MM/YYYY')}
})
